import axios from '../settings/axios'
import { apiEndpoints } from '../settings/_apiSettings'
import { CANCELED } from '../settings/_scheduleStatusSettings'

export interface CancelScheduleRequest {
  scheduleId: string
  reasonCode: string
  requestedBy: string
}

export interface CancelScheduleResponse {
  data: {
    id: string
  }
}

export async function cancelScheduleService({
  scheduleId,
  reasonCode,
  requestedBy
}: CancelScheduleRequest): Promise<CancelScheduleResponse> {
  const requestBody = {
    status_code: CANCELED,
    reason_code: reasonCode,
    requested_by: requestedBy
  }

  const response = await axios.put<CancelScheduleResponse>(
    apiEndpoints.SCHEDULE_DETAIL(scheduleId),
    requestBody
  )

  return {
    ...response,
    data: {
      id: scheduleId
    }
  }
}
